import "./App.css";
import { CsvToJsonConverter } from "./util/CsvToJsonConverter";
import { useEffect, useRef, useState } from "react";
import { categorizeByStepAndContext } from "./util/GroupVariantsByContext";
// import { renderUI } from "./util/jsonToUIConverter";
// import interface1 from "./jsonSamples/interface1.json";
import GLBViewer from "./elements/GlbSeatModel/GlbSeatModel";
import { CameraAnimationTrigger } from "./util/AnimateCameraPosition";
import { useAuth } from "react-oidc-context";
import LoadingPage from "./elements/LoadingPage/LoadingPage";
// import { redirectUri } from "./variables/uris";
import PageContainer from "./elements/PageContainer/PageContainer";
import OptionsMenu from "./elements/OptionsMenu/OptionsMenu";
import { generateInitialSelections } from "./util/GenerateInitialSelections";
import { retrievUserConfiguration } from "./util/RetrievUserConfiguration";
import { macModelUrls, phoModelUrls } from "./util/modelUrls";
import { ProductInfoBox } from "./elements/ProductInfoBox/ProductInfoBox";
import ReviewSection from "./elements/ReviewSection/ReviewSection";
import UnsavedConfigsModal from "./elements/UnsavedConfigsModal/UsavedConfigsModal";
import SuccessPage from "./elements/SuccessPage/SuccessPage";
import { createTheme, ThemeProvider } from "@mui/material";
import FullScreenOnboarding from "./elements/OnboardingPage/OnboardingPage";
import { RetrievCustomFiles } from "./util/RetrievCustomFiles";
import { getCost } from "./util/getCost";
import ControlsGuide from "./elements/ControlsGuide/ControlGuide";
import ButtonIcon from "./elements/ButtonIcon/ButtonIcon";
import { BrunchDining, LightMode, Videocam } from "@mui/icons-material";

const COST_RULES = {
  NRE: { Baseline: 500000, Low: 25000, Med: 100000, High: 250000 },
  REC: { Baseline: 26000, Low: 50, Med: 250, High: 550 },
  Lead: { Baseline: 10, Low: 0, Med: 6, High: 12 },
  Airplane: { Baseline: 0, Low: 10000, Med: 50000, High: 110000 },
};

function App() {
  const [data, setData] = useState(null);
  const [groupedData, setGroupedData] = useState(null);
  const [dataSelection, setDataSelection] = useState({});
  const [cost, setCost] = useState({});
  const [customFiles, setCustomFiles] = useState([]);
  const [retrievedDataSelection, setRetrievedDataSelection] = useState({});
  const [recallRetrievedData, setRecallRetrievedData] = useState(false);
  const [dataCateg, setDataCateg] = useState("");
  const [dataOption, setDataOption] = useState("");
  const [seatType] = useState("Pho");
  const [product, setProduct] = useState("");
  const [productBodyType, setProductBodyType] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [authUser, setAuthUser] = useState(null);
  const [configId, setConfigId] = useState();
  const [page, setPage] = useState("configurator");
  const [dbCost, setDbCost] = useState([]);
  const [isNight, setIsNight] = useState(false);
  const [isFoodTrayVisible, setIsFoodTrayVisible] = useState(true);
  // const [openReview, setOpenReview] = useState(false);
  const [glbsLoaded, setGlbsLoaded] = useState(false);
  const [succRequestStages, setSuccRequestStages] = useState("null");
  const captureCallbackRef = useRef(null);
  const [submittedConfigObj, setSubmittedConfigObj] = useState({});
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        sm_md: 900,
        md: 1000,
        md_lg: 1070,
        lg: 1200,
        lg_xl_1: 1300,
        lg_xl_2: 1400,
        xl: 1536,
      },
    },
  });

  useEffect(() => {
    if (succRequestStages === "sent") {
      setTimeout(() => {
        setSuccRequestStages("loading");
      }, 350);
      setTimeout(() => {
        setSuccRequestStages("successMsg");
      }, 3000);
    }
  }, [succRequestStages]);

  useEffect(() => {
    if (dataCateg === "FOOD TRAY") {
      setIsFoodTrayVisible(true);
    }
    if (dataCateg === "ARMREST") {
      setIsFoodTrayVisible(false);
    }
  }, [dataCateg]);

  useEffect(() => {
    var csvFileName = seatType === "Mac" ? "/data_mac.csv" : "/data_pho.csv";
    CsvToJsonConverter(csvFileName).then((d) => {
      let data_ = d;

      let excludeProduct =
        productBodyType.toLowerCase().indexOf("narrowbody") > -1
          ? "widebody"
          : "narrowbody";
      if (productBodyType !== "") {
        data_ = d.filter((opt) => opt.VariantID.indexOf(excludeProduct) === -1);
      }

      setData(data_);
      setGroupedData(categorizeByStepAndContext(data_)); // create nested json of the options
      setDataSelection(generateInitialSelections(data_)); // Initiate default selections
    });
  }, [seatType, productBodyType]);

  function getDataElementById(variantID) {
    return data.filter((d) => d.VariantID === variantID)[0];
  }

  function getFirstElementByCntx(content) {
    return data.filter((d) => d.Context === content)[0];
  }

  function initialCascadeSelection(stepData, parentData, dataValue) {
    let element = getDataElementById(dataValue);

    if (element) {
      let cascadeContextArr = element.Cascades;
      let decascadeContextArr = element.Decascades;

      if (cascadeContextArr !== "-") {
        cascadeContextArr.split("|").forEach((casc) => {
          if (casc !== "-") {
            let elem = getFirstElementByCntx(casc);
            if (elem) {
              parentData[casc] = elem.VariantID;
              const cascadeParentData = {
                ...(stepData[elem.CascadeName] || {}),
                [casc]: elem.VariantID,
              };
              stepData[elem.CascadeName] = cascadeParentData;
              if (elem.Cascades !== "-")
                parentData = initialCascadeSelection(
                  stepData,
                  parentData,
                  elem.VariantID,
                );
            }
          }
        });
      }
      if (decascadeContextArr !== "-") {
        decascadeContextArr.split("|").forEach((decasc) => {
          if (decasc !== "-") {
            parentData[decasc] = "-";
            let elem = getFirstElementByCntx(decasc);
            if (elem) {
              stepData[elem.CascadeName] = {
                ...(stepData[elem.CascadeName] || {}),
                [decasc]: "-",
              };
            }
          }
        });
      }
    }
    return parentData;
  }

  // When user changes the configs
  function changeConfigs(
    SubStepTitle,
    CascadeName,
    context,
    dataValue,
    remove = false,
  ) {
    setDataSelection((prev) => {
      // clone current step object or start fresh
      let stepData = { ...(prev[SubStepTitle] || {}) };

      // clone current parent object or start fresh
      let parentData = { ...(stepData[CascadeName] || {}) };

      if (remove) {
        // remove the entry
        delete parentData[context];

        // if parentData is now empty, remove the parent
        if (Object.keys(parentData).length === 0) {
          delete stepData[CascadeName];
        }
      } else {
        parentData[context] = dataValue;
        parentData = initialCascadeSelection(stepData, parentData, dataValue);
      }

      // // update stepData with the modified parentData

      return {
        ...prev,
        [SubStepTitle]: {
          ...stepData,
          ...(Object.keys(parentData).length > 0 && {
            [CascadeName]: parentData,
          }),
        },
      };
    });
  }

  useEffect(() => {
    document.getElementsByTagName("body")[0].style.backgroundColor = isNight
      ? "#7a8197"
      : "#e7e7e9";
  }, [isNight]);

  function getCostsByComplexity(complexity, weight) {
    // We use "|| 0" to ensure that if a lookup fails, it defaults to a number
    return {
      NRE: COST_RULES.NRE[complexity] || 0,
      REC: COST_RULES.REC[complexity] || 0,
      Weight: weight && weight !== "-" ? parseFloat(weight) || 0 : 0,
      Lead: parseFloat(COST_RULES.Lead[complexity]) || 0,
    };
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function walkNestedObject(obj, callback) {
    function recurse(value, path) {
      if (typeof value === "string") {
        let variant = data.find((d) => {
          let value_ = value.indexOf("_#") > -1 ? value.split("_#")[0] : value;
          return d.VariantID === value_;
        });

        if (variant) {
          callback(
            variant.Complexity,
            variant.Weight,
            variant.VariantID,
            variant.Context,
          );
        }
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((item, index) => recurse(item, [...path, index]));
        return;
      }

      if (value && typeof value === "object") {
        Object.entries(value).forEach(([key, val]) =>
          recurse(val, [...path, key]),
        );
      }
    }
    recurse(obj, []);
  }

  function getCostsByVariantId(variantID) {
    let cost = { nre: 0, rec: 0, weight: 0, lead_time: 0 };
    if (dbCost.length !== 0)
      cost = dbCost.filter((dbC) => {
        // console.log(dbC.variant_id);
        // console.log(variantID);
        // console.log("-----------");

        return dbC.variant_id === variantID;
      })[0];
    // console.log(cost);
    return cost;
  }

  useEffect(() => {
    setCost(() => {
      const dataCost_ = {};

      walkNestedObject(
        dataSelection,
        (complexity, weight, variantID, context) => {
          const costs = getCostsByVariantId(variantID);

          // Accumulate costs for this specific context
          if (!dataCost_[context]) {
            dataCost_[context] = { NRE: 0, REC: 0, Weight: 0, Lead: 0 };
          }

          if (costs) {
            dataCost_[context].NRE += costs?.nre;
            dataCost_[context].REC += costs?.rec;
            dataCost_[context].Weight += costs?.weight;
            dataCost_[context].Lead += costs?.lead_time;
          }
        },
      );

      let stepsTotal = { NRE: 0, REC: 0, Weight: 0, Lead: 0 };
      const dtCstFnl = {};

      Object.entries(dataCost_).forEach(([key, value]) => {
        const variantData = data.find((d) => key === d.Context);
        const stepTitle = variantData?.StepTitle || "Unknown Step";

        // Initialize Step if it doesn't exist
        if (!dtCstFnl[stepTitle]) {
          dtCstFnl[stepTitle] = {
            "ALL STEPS": { NRE: 0, REC: 0, Weight: 0, Lead: 0 },
          };
        }

        // Add context data to the step
        dtCstFnl[stepTitle][key] = value;

        // Update "ALL STEPS" rollup for this category
        const allSteps = dtCstFnl[stepTitle]["ALL STEPS"];
        allSteps.NRE += value.NRE;
        allSteps.REC += value.REC;
        allSteps.Weight += value.Weight;
        allSteps.Lead += value.Lead;

        // Update Grand Total
        stepsTotal.NRE += value.NRE;
        stepsTotal.REC += value.REC;
        stepsTotal.Weight += value.Weight;
        stepsTotal.Lead += value.Lead;
      });

      dtCstFnl["TOTAL COST"] = stepsTotal;
      return dtCstFnl;
    });
    // Print out all values
    // let g = [];
    // data?.map((d) => {
    //   let m = { nre: 0, rec: 0, weight: 0, lead_time: 0, variant_id: "" };
    //   const costs = getCostsByComplexity(d.Complexity, d.Weight);
    //   g.push({
    //     nre: costs.NRE,
    //     rec: costs.REC,
    //     weight: costs.Weight,
    //     lead_time: costs.Lead,
    //     variant_id: d.VariantID,
    //   });
    // });
    // console.log(g);
  }, [dataSelection, data, dbCost]); // Added 'data' to dependencies for safety

  function addToCustomFiles(variantID, Base64File) {
    setCustomFiles((prev) => {
      // Find if the variant already exists
      const exists = prev.some((item) => Object.keys(item)[0] === variantID);

      if (exists) {
        // Replace the existing entry with the new one
        return prev.map((item) =>
          Object.keys(item)[0] === variantID
            ? { [variantID]: Base64File }
            : item,
        );
      }

      // Otherwise, add new entry
      return [...prev, { [variantID]: Base64File }];
    });
  }

  function removeFromCustomFiles(variantID) {
    setCustomFiles((prev) =>
      prev.filter((item) => Object.keys(item)[0] !== variantID),
    );
  }

  function showReviewPage() {
    setPage("review");
  }

  const animateCamTriggerRef = useRef();
  const sceneRootRef = useRef();

  const fireCameraAnimation = (camPosition, seatCode) => {
    animateCamTriggerRef.current?.fireCameraAnimation(camPosition, seatCode);
  };

  const resetCamera = () => {
    animateCamTriggerRef.current?.resetCamera();
  };

  const auth = useAuth();

  // const signOutRedirect = () => {
  //   const clientId = "177c8jpsapihgr4lm7hh7eag66";
  //   const logoutUri = redirectUri;
  //   const cognitoDomain =
  //     "https://us-east-1omkp1vzyq.auth.us-east-1.amazoncognito.com";
  //   window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
  //     logoutUri
  //   )}`;
  // };

  if (auth.isLoading) {
    return <LoadingPage></LoadingPage>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  function formatNumber(number) {
    return number.toLocaleString(
      undefined, // leave undefined to use the visitor's browser
      // locale or a string like 'en-US' to override it.
      { minimumFractionDigits: 2 },
    );
  }

  // Example usage
  const sampleData = {
    title: "PRODUCT INFO",
    rows: [
      {
        label: "TOTAL COST",
        value: "$" + formatNumber(cost["TOTAL COST"].NRE),
      },
      { label: "REC", value: "$" + formatNumber(cost["TOTAL COST"].REC) },
      { label: "WEIGHT", value: cost["TOTAL COST"].Weight },
      { label: "LEAD TIME", value: cost["TOTAL COST"].Lead + " Week/s" },
    ],
  };

  let sampleData2Rows = [];
  // eslint-disable-next-line array-callback-return
  Object.entries(cost).map(([key, value]) => {
    if (value["ALL STEPS"]?.NRE || value["ALL STEPS"]?.NRE === 0)
      sampleData2Rows.push({
        label: key,
        value: "$" + formatNumber(value["ALL STEPS"].NRE),
      });
  });
  const sampleData2 = {
    title: "COST BREAKDOWN",
    rows: sampleData2Rows,
  };

  function reflectRetrievedDataSelection() {
    const mergeSelections = (base, retrieved) => {
      if (
        !base ||
        typeof base !== "object" ||
        Array.isArray(base) ||
        !retrieved ||
        typeof retrieved !== "object" ||
        Array.isArray(retrieved)
      ) {
        return retrieved ?? base;
      }

      const merged = { ...base };

      Object.keys(retrieved).forEach((key) => {
        if (key in base) {
          merged[key] = mergeSelections(base[key], retrieved[key]);
        }
      });

      return merged;
    };

    const merged = mergeSelections(dataSelection, retrievedDataSelection);

    setDataSelection(merged);
    setRecallRetrievedData(true);
    RetrievCustomFiles(auth.user?.id_token, configId).then((cstmFl) => {
      setCustomFiles(cstmFl);
    });
  }

  if (auth.isAuthenticated) {
    if (authUser === null) {
      setAuthUser(auth.user);
      retrievUserConfiguration(auth.user?.id_token).then((d) => {
        // console.log(d?.["config"]);
        setRetrievedDataSelection(d?.["config"]);
        setConfigId(d?.["config_id"]);
      });
      getCost(auth.user?.id_token).then((d) => {
        setDbCost(d);
      });
    }
    return (
      <ThemeProvider theme={theme}>
        <div className={`App ${isNight ? "App--night" : ""}`}>
          {succRequestStages === "null" || succRequestStages === "sent" ? (
            <div
              style={{
                opacity: succRequestStages === "sent" ? 0 : 1,
                transition: "opacity 0.35s ease",
              }}
            >
              {glbsLoaded && (
                <UnsavedConfigsModal
                  retrievedDataSelection={retrievedDataSelection}
                  reflectRetrievedDataSelection={reflectRetrievedDataSelection}
                  isNight={isNight}
                />
              )}
              {groupedData ? (
                <div style={{ position: "relative" }}>
                  <PageContainer>
                    {/* <div
                      style={{
                        height: "8px",
                        width: "100%",
                        backgroundColor: "#bd2d2f",
                      }}
                    ></div> */}

                    {/* */}
                    {companyName === "" ? (
                      <>
                        <div
                          style={{
                            position: "absolute",
                            height: "25px",
                            padding: "2.5vh 3vh",
                            zIndex: "999999",
                            textAlign: "left",
                          }}
                        >
                          <img
                            src={"/Assets/CA-Logo_rgb-black.png"}
                            alt="logo"
                            style={{
                              height: "100%",
                              filter: isNight
                                ? "brightness(0) invert(1)"
                                : "none",
                              transition: "filter 0.35s ease",
                            }}
                          />
                        </div>
                        <FullScreenOnboarding
                          setCompanyName={setCompanyName}
                          setProduct={setProduct}
                          setProductBodyType={setProductBodyType}
                        ></FullScreenOnboarding>
                      </>
                    ) : (
                      <>
                        <ReviewSection
                          open={page === "review"}
                          data={sampleData}
                          moreData={sampleData2}
                          page={page}
                          setPage={setPage}
                          authUser={authUser}
                          dataSelection={dataSelection}
                          cost={cost}
                          customFiles={customFiles}
                          productBodyType={productBodyType}
                          product={product}
                          companyName={companyName}
                          setSuccRequestStages={setSuccRequestStages}
                          captureCallbackRef={captureCallbackRef}
                          setSubmittedConfigObj={setSubmittedConfigObj}
                          glbsLoaded={glbsLoaded}
                          isNight={isNight}
                        />
                        <div
                          style={{
                            position: "absolute",
                            height: "25px",
                            padding: "3vh 3vh",
                            zIndex: "999999",
                            textAlign: "left",
                          }}
                        >
                          <img
                            src={"/Assets/CA-Logo_rgb-black.png"}
                            alt="logo"
                            style={{
                              height: "100%",
                              filter: isNight
                                ? "brightness(0) invert(1)"
                                : "none",
                              transition: "filter 0.35s ease",
                            }}
                          />
                          <div
                            style={{
                              marginTop: "20px",
                              fontSize:
                                "calc(0.74rem + var(--large-screen-font-bump))",
                            }}
                          >
                            <span
                              style={{
                                fontWeight: "600",
                                color: isNight ? "#f4f6fa" : "inherit",
                                transition: "color 0.35s ease",
                              }}
                            >
                              {product}
                            </span>
                            <span
                              style={{
                                color: isNight ? "#d7dce6" : "#5b5b5b",
                                transition: "color 0.35s ease",
                              }}
                            >
                              {" - " + productBodyType}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{
                            position: "absolute",
                            right: "0px",
                            zIndex: "999",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-start",
                            }}
                          >
                            <div>
                              <ProductInfoBox
                                data={sampleData}
                                moreData={sampleData2}
                                show={page === "configurator"}
                                isNight={isNight}
                              />
                              <ControlsGuide isNight={isNight}></ControlsGuide>
                              <ButtonIcon
                                tooltipTitle={isNight ? "Daylight" : "Night"}
                                onClick={() => {
                                  setIsNight(!isNight);
                                }}
                                icon={<LightMode />}
                                top={"calc(14vh + 100px)"}
                                right={"3vh"}
                                isNight={isNight}
                              ></ButtonIcon>
                              <ButtonIcon
                                tooltipTitle={"Reset Camera"}
                                onClick={resetCamera}
                                icon={<Videocam />}
                                top={"calc(19vh + 100px)"}
                                right={"3vh"}
                                isNight={isNight}
                              ></ButtonIcon>
                              <ButtonIcon
                                tooltipTitle={
                                  isFoodTrayVisible
                                    ? "Hide Food Tray"
                                    : "Show Food Tray"
                                }
                                onClick={() =>
                                  setIsFoodTrayVisible(!isFoodTrayVisible)
                                }
                                icon={<BrunchDining />}
                                top={"calc(24vh + 100px)"}
                                right={"3vh"}
                                isNight={isNight}
                              ></ButtonIcon>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            overflow: "hidden",
                            position: "relative",
                            height: "calc(100vh - 6vh)",
                          }}
                        >
                          <div
                            style={{
                              position: "absolute",
                              left: page === "review" ? "-25vw" : "0vw",
                              // transform:
                              //   page === "review" ? "scale(0.89)" : "scale(1)",
                              // transformOrigin: "-170vw center",
                              transition: "left 0.5s ease",
                              height: "calc(100vh - 6vh)",
                              width: "calc(100vw - 6vh)",
                            }}
                          >
                            {seatType === "Mac" ? (
                              <GLBViewer
                                key="Mac"
                                dataCateg={dataCateg}
                                dataOption={dataOption}
                                data={data}
                                groupedData={groupedData}
                                dataSelection={dataSelection}
                                setGlbsLoaded={setGlbsLoaded}
                                sceneRootRef={sceneRootRef}
                                captureCallbackRef={captureCallbackRef}
                                isNight={isNight}
                                isFoodTrayVisible={isFoodTrayVisible}
                                cameraAnimationTrigger={
                                  <CameraAnimationTrigger
                                    triggerRef={animateCamTriggerRef}
                                    sceneRootRef={sceneRootRef}
                                  />
                                }
                                modelUrls={macModelUrls}
                              />
                            ) : (
                              <GLBViewer
                                key="pho"
                                dataCateg={dataCateg}
                                dataOption={dataOption}
                                data={data}
                                groupedData={groupedData}
                                dataSelection={dataSelection}
                                setGlbsLoaded={setGlbsLoaded}
                                sceneRootRef={sceneRootRef}
                                captureCallbackRef={captureCallbackRef}
                                isNight={isNight}
                                isFoodTrayVisible={isFoodTrayVisible}
                                cameraAnimationTrigger={
                                  <CameraAnimationTrigger
                                    triggerRef={animateCamTriggerRef}
                                    sceneRootRef={sceneRootRef}
                                  />
                                }
                                modelUrls={phoModelUrls}
                              />
                            )}
                          </div>

                          <OptionsMenu
                            data={data}
                            productBodyType={productBodyType
                              ?.split(" ")[0]
                              .toLowerCase()}
                            groupedData={groupedData}
                            setDataCateg={setDataCateg}
                            setDataOption={setDataOption}
                            dataCateg={dataCateg}
                            dataOption={dataOption}
                            dataSelection={dataSelection}
                            retrievedDataSelection={retrievedDataSelection}
                            recallRetrievedData={recallRetrievedData}
                            changeConfigs={changeConfigs}
                            customFiles={customFiles}
                            addToCustomFiles={addToCustomFiles}
                            authUser={authUser}
                            fireCameraAnimation={fireCameraAnimation}
                            showReviewPage={showReviewPage}
                            page={page}
                            open={page === "configurator"}
                            isNight={isNight}
                          ></OptionsMenu>
                        </div>{" "}
                      </>
                    )}
                  </PageContainer>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          ) : (
            <>
              {succRequestStages === "loading" ? (
                <LoadingPage />
              ) : (
                <SuccessPage
                  data={sampleData}
                  moreData={sampleData2}
                  isNight={isNight}
                  idToken={auth.user?.id_token}
                  first_name={auth.user.profile["cognito:username"]}
                  last_name={""}
                  configObj={submittedConfigObj}
                  glbViewer={
                    <GLBViewer
                      key="Pho"
                      dataCateg={dataCateg}
                      dataOption={dataOption}
                      data={data}
                      groupedData={groupedData}
                      dataSelection={dataSelection}
                      setGlbsLoaded={setGlbsLoaded}
                      sceneRootRef={sceneRootRef}
                      captureCallbackRef={captureCallbackRef}
                      isNight={isNight}
                      isFoodTrayVisible={isFoodTrayVisible}
                      cameraAnimationTrigger={
                        <CameraAnimationTrigger
                          triggerRef={animateCamTriggerRef}
                          sceneRootRef={sceneRootRef}
                        />
                      }
                      modelUrls={phoModelUrls}
                    />
                  }
                ></SuccessPage>
              )}
            </>
          )}
        </div>
      </ThemeProvider>
    );
    // (
    //   <div>
    //     <pre> Hello: {auth.user?.profile.email} </pre>
    //     <pre> ID Token: {auth.user?.id_token} </pre>
    //     <pre> Access Token: {auth.user?.access_token} </pre>
    //     <pre> Refresh Token: {auth.user?.refresh_token} </pre>

    //     <button onClick={() => auth.removeUser()}>Sign out</button>
    //   </div>
    // );
  }

  if (!auth.isAuthenticated) {
    auth.signinRedirect();
    return <div></div>;
  }
}

export default App;
